import { createSelector } from 'reselect'

export const getCurrentSubCategory = createSelector(
  (state) => state && state.categories && state.categories.currentSubcategory ? state.categories.currentSubcategory : null,
  (category) => category
)
